module.exports = __webpack_public_path__ + "img/05.ca7e65c1.jpg";